"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
exports.__esModule = true;
exports.default = exports.ListItem = void 0;
var React = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _defaultTheme = _interopRequireDefault(require("../defaultTheme"));
var _consts = require("./consts");
var _getSpacingToken = _interopRequireDefault(require("../common/getSpacingToken"));
var _ListItem = _interopRequireWildcard(require("./ListItem"));
exports.ListItem = _ListItem.default;
var _ListContext = _interopRequireDefault(require("./ListContext"));
const getSizeToken = ({
  theme,
  size
}) => {
  const sizeTokens = {
    [_consts.SIZES.SMALL]: theme.orbit.fontSizeTextSmall,
    [_consts.SIZES.NORMAL]: theme.orbit.fontSizeTextNormal,
    [_consts.SIZES.LARGE]: theme.orbit.fontSizeTextLarge
  };
  if (!size) return null;
  return sizeTokens[size];
};
const getTypeToken = ({
  theme,
  type
}) => {
  const typeTokens = {
    [_consts.TYPES.PRIMARY]: theme.orbit.colorTextPrimary,
    [_consts.TYPES.SECONDARY]: theme.orbit.colorTextSecondary
  };
  if (!type) return null;
  return typeTokens[type];
};
const StyledList = _styledComponents.default.ul.withConfig({
  displayName: "List__StyledList",
  componentId: "sc-cesfjx-0"
})(["", ";"], ({
  theme
}) => (0, _styledComponents.css)(["display:flex;width:100%;flex-direction:column;font-family:", ";font-size:", ";line-height:", ";color:", ";list-style:none;padding:0;margin:0;margin-bottom:", ";"], theme.orbit.fontFamily, getSizeToken, _ListItem.getLineHeightToken, getTypeToken, _getSpacingToken.default));
StyledList.defaultProps = {
  theme: _defaultTheme.default
};
const List = ({
  children,
  size = _consts.SIZES.NORMAL,
  type = _consts.TYPES.PRIMARY,
  dataTest,
  id,
  spaceAfter
}) => {
  const value = React.useMemo(() => ({
    size,
    type
  }), [size, type]);
  return /*#__PURE__*/React.createElement(StyledList, {
    type: type,
    size: size,
    "data-test": dataTest,
    id: id,
    spaceAfter: spaceAfter
  }, /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
    value: value
  }, children));
};
var _default = List;
exports.default = _default;